import { Exclude } from 'class-transformer';

export class OwnerBasicDetailsRawDto {
  title: string;
  firstName: string;
  lastName: string;

  @Exclude()
  get displayName(): string {
    return `${this.title || ''} ${this.firstName || ''} ${this.lastName || ''}`.trim();
  }
}
